// @ts-nocheck
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    PopulateApiParameter,
    chain,
    CallUpdateAccount,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SaveCurrentAccount";
import { toToolkitApplicationState } from "@toolkit/Framework/Store/ApplicationState";
import { addToChainBefore } from "@toolkit/Modules/client-framework/HandlerCreator";
import cloneDeep from "lodash/cloneDeep";
import constants from "@store/constants";

addToChainAfter(chain, PopulateApiParameter, props => {
    const { firstName, languageId, lastName } = toToolkitApplicationState(props.getState()).bunzl.pages.accountSettings;
    const accountCopy = cloneDeep(props.apiParameter.account);
    if (firstName) {
        accountCopy.firstName = firstName;
    }
    if (languageId) {
        accountCopy.properties.languageId = languageId;
    }
    if (lastName) {
        accountCopy.lastName = lastName;
    }
    props.apiParameter.account = accountCopy;
});

// A bit awkward but some properties can be updated so the normal handler chain of copying the account
// won't work as sending those values on the update call will cause an error.  We add this handler to remove any properties not allowed.
addToChainBefore(chain, CallUpdateAccount, props => {
    const properties = Object.entries(props.apiParameter.account.properties);
    const filteredProperties = properties.reduce<{ [key: string]: string }>((acc, [key, value]) => {
        if (constants.allowedPropertiesForUpdate.includes(key)) {
            acc[key] = value;
        }
        return acc;
    }, {});

    props.apiParameter = {
        ...props.apiParameter,
        account: {
            ...props.apiParameter.account,
            properties: filteredProperties,
        },
    };
});
